import { render, staticRenderFns } from "./PerfilMenuPage.vue?vue&type=template&id=e7f0a32a"
import script from "./PerfilMenuPage.vue?vue&type=script&lang=js"
export * from "./PerfilMenuPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports